/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Stock_EmptyInputs */

const vi_tea_grade_stock_empty = /** @type {(inputs: Tea_Grade_Stock_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại này đang không còn lô tồn trong kho.`)
};

/**

* @param {Tea_Grade_Stock_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_empty = /** @type {((inputs?: Tea_Grade_Stock_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_empty(inputs)
});